import { RecordStatus } from '../../types/menu/enums.types';
import { PermissionLevel, UserPermissionType } from '../../types/public/enum.types';

export const clockMPosModule = {
  'clock-in-module-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 14,
    featureId: null,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'clock-in-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 14,
    featureId: 133,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'login-without-clock-in-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 14,
    featureId: 45,
    key: 'login-without-clock-in-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'device-status-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 14,
    featureId: 46,
    key: 'device-status-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'clock-in-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 14,
    featureId: 133,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'login-without-clock-in-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 14,
    featureId: 45,
    key: 'login-without-clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'device-status-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 14,
    featureId: 46,
    key: 'device-status-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const loginMPosModule = {
  'login-module-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: null,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'login-visible-isApprovalNeed': {
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: 77,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'login-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: 77,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const tableLayoutMPosModule = {
  'table-layout-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: null,
    key: 'table-layout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'other-tables-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: 78,
    key: 'other-tables-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'table-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: 190,
    key: 'table-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'table-status-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: 191,
    key: 'table-status-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'switch-floors-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: 192,
    key: 'switch-floors-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'view-seating-capacity-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: 193,
    key: 'view-seating-capacity-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'assign-server-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: 195,
    key: 'assign-server-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'other-tables-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: 78,
    key: 'other-tables-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'table-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: 190,
    key: 'table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'table-status-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: 191,
    key: 'table-status-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'switch-floors-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: 192,
    key: 'switch-floors-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'view-seating-capacity-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: 193,
    key: 'view-seating-capacity-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'assign-server-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: 195,
    key: 'assign-server-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const menuMPosModule = {
  'menu-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: null,
    key: 'menu-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'item-level-comp-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 51,
    key: 'item-level-comp-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'void-items-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 79,
    key: 'void-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'edit-service-charge-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 80,
    key: 'edit-service-charge-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'item-level-comp--is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 51,
    key: 'item-level-comp-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'void-items-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 79,
    key: 'void-items-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'edit-service-charge-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 80,
    key: 'edit-service-charge-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const ticketMPosModule = {
  'ticket-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: null,
    key: 'ticket-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tax-exempt-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 57,
    key: 'tax-exempt-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'change-table-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 58,
    key: 'change-table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'change-server-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 59,
    key: 'change-server-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'void-order-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 60,
    key: 'void-order-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'ticket-level-comp-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 61,
    key: 'ticket-level-comp-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'custom-item-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 81,
    key: 'custom-item-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'service-charges-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 194,
    key: 'service-charges-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tax-exempt-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 57,
    key: 'tax-exempt-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'change-table-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 58,
    key: 'change-table-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'change-server-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 59,
    key: 'change-server-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'void-order-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 60,
    key: 'void-order-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'ticket-level-comp-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 61,
    key: 'ticket-level-comp-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'custom-item-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 81,
    key: 'custom-item-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'service-charges-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 194,
    key: 'service-charges-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const paymentMPosModule = {
  'payments-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 43,
    featureId: null,
    key: 'payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'refund-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 43,
    featureId: 26,
    key: 'refund-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'update-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'adjust-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 43,
    featureId: 54,
    key: 'adjust-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tenders-visible': {
    permissionId: 5,
    appId: 3,
    moduleId: 43,
    featureId: 134,
    key: 'tenders-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },

  'refund-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 43,
    featureId: 26,
    key: 'refund-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'update-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'adjust-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 43,
    featureId: 54,
    key: 'adjust-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tenders-visible-is-approval-needed': {
    permissionId: 5,
    appId: 3,
    moduleId: 43,
    featureId: 134,
    key: 'tenders-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
